<div class="values">
  <div class="item" *ngFor="let val of value">
    <a href="{{val.links?.open}}" target="_blank">{{val.name}}</a>
  </div>
  <div class="none" *ngIf="!value.length">-</div>
</div>
